import { VariationCollectionType } from '@pcln/contentful-components'

export default function isContentVariationCollectionType<T>(
  content: T | VariationCollectionType | undefined
): content is VariationCollectionType {
  return (
    content !== undefined &&
    (content as VariationCollectionType).experimentName != null &&
    (content as VariationCollectionType).experimentName.trim() !== ''
  )
}
